import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#button-group" }),
  /*#__PURE__*/_createTextVNode(" Button Group ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Displayed as a button group, can be used to group a series of similar operations. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Previous Page")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Next Page")
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-right el-icon-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_button_group = _resolveComponent("el-button-group")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-arrow-left"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_button_group, { class: "group2" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-edit"
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-share"
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-delete"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
}